import { render, staticRenderFns } from "./FinalSpouseSignBoard.vue?vue&type=template&id=0f8da475&scoped=true"
import script from "./FinalSpouseSignBoard.vue?vue&type=script&lang=js"
export * from "./FinalSpouseSignBoard.vue?vue&type=script&lang=js"
import style0 from "./FinalSpouseSignBoard.vue?vue&type=style&index=0&id=0f8da475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8da475",
  null
  
)

/* custom blocks */
import block0 from "./FinalSpouseSignBoard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports